import { RiTableLine } from '@remixicon/react';

import { isTableBlockTool } from '@spotify/confidence-core-react';
import { createToolExtension } from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

export const CreateTableBlockToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-table-block',
    predicate: isTableBlockTool,
    icon: RiTableLine,
    display: 'grouped',
    render: () => null,
    renderTool: () => null,
  }),
);
